import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { PieDataItem } from './pie/pie';

@Component({
    selector: 'dashboard',
    templateUrl: 'dashboard.html',
    styleUrls: ['dashboard.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardComponent implements OnInit {
    @Input() groupId;
    @Output() created = new EventEmitter();

    loadingData = true;
    // gymers: any[] = [];
    // gyms: any[] = [];
    // coaches: any[] = [];
    // shops: any[] = [];
    // groups: any[] = [];
    // posts: any[] = [];


    gymersValue: any[] = [];
    coachesValue: any[] = [];
    gymsValue: any[] = [];
    shopsValue: any[] = [];
    groupsValue: any[] = [];
    postsValue: any[] = [];

    gymers7Days: any;
    coaches7Days: any;
    gyms7Days: any;
    shops7Days: any;
    groups7Days: any;
    posts7Days: any;


    constructor(private http: HttpClient) {
    }

    ngOnInit() {
        this.load();
    }

    load() {
        this.http.get<any>('/dashboard/totals').subscribe(result => {
            this.gymersValue = result.totals.find(a => a.type === 1)?.count ?? 0;
            this.coachesValue = result.totals.find(a => a.type === 2)?.count ?? 0;
            this.gymsValue = result.totals.find(a => a.type === 3)?.count ?? 0;
            this.shopsValue = result.totals.find(a => a.type === 4)?.count ?? 0;
            this.groupsValue = result.totals.find(a => a.type === 100)?.count ?? 0;
            this.postsValue = result.totals.find(a => a.type === 200)?.count ?? 0;

            this.gymers7Days = result.totals7Days.find(a => a.type === 1)?.count ?? 0;
            this.coaches7Days = result.totals7Days.find(a => a.type === 2)?.count ?? 0;
            this.gyms7Days = result.totals7Days.find(a => a.type === 3)?.count ?? 0;
            this.shops7Days = result.totals7Days.find(a => a.type === 4)?.count ?? 0;
            this.groups7Days = result.totals7Days.find(a => a.type === 100)?.count ?? 0;
            this.posts7Days = result.totals7Days.find(a => a.type === 200)?.count ?? 0;

            // this.gymers = [{
            //     value: result.find(a => a.type === 1)?.count || 0
            // }];
            // this.coaches = [{
            //     value: result.find(a => a.type === 2)?.count || 0
            // }];
            // this.gyms = [{
            //     value: result.find(a => a.type === 3)?.count || 0
            // }];
            // this.shops = [{
            //     value: result.find(a => a.type === 4)?.count || 0
            // }];
            // this.groups = [{
            //     value: result.find(a => a.type === 100)?.count || 0
            // }];
            // this.posts = [{
            //     value: result.find(a => a.type === 200)?.count || 0
            // }];

            this.loadingData = false;
        });
    }
}
